export default __webpack_public_path__ + "static/media/cad5.647f1135.png";